<template>
  <emd-modal
    scrollable
    has-header
    has-footer
    :open="isOpen"
    size="large"
    @close="onClose"
  >
    <template v-slot:header>
      <h2 class="emd-text _size_section _color_contrast">
        {{ $t('modal.boleto-stone.modal-fail-habilitation.title') }}
      </h2>
    </template>
    <template v-slot:content>
      <h2 class="emd-text _color_subtle">
        {{ $t('modal.boleto-stone.modal-fail-habilitation.paragraph-1') }}
      </h2>
    </template>
    <template v-slot:footer>
      <emd-button
        v-on:click="onClose"
        class="emd-btn _size_big _block"
        color="primary"
        size="big"
        :block="true"
      >
        {{ $t('modal.boleto-stone.modal-fail-habilitation.button-ok') }}
      </emd-button>
    </template>
  </emd-modal>
</template>

<script>
import { EmdModal, EmdButton } from 'emerald-vue/src/components'

export default {
  name: 'ModalFailHabilitation',
  components: { EmdModal, EmdButton },
  props: {
    isOpen: {
      type: Boolean
    },
    onClose: {
      type: Function,
      default: () => ({})
    }
  }
}
</script>
